// 团队有无权限
export const teamHasAuth = (code) => {
  let teamCodes = []
  try {
    teamCodes = JSON.parse(localStorage.teamAuthCodeList)
  } catch (error) {
    console.warn(error)
  }
  return teamCodes?.some(m => m === code)
}
// 个人有无权限
export const hasAuth = (code) => {
  let useCodes = []
  try {
    useCodes = JSON.parse(localStorage.userAuthCodeList)
  } catch (error) {
    console.warn(error)
  }
  return useCodes?.some(m => m === code)
}

// 样衣有无权限
export const sampleHasAuth = (code) => {
  let useCodes = []
  try {
    useCodes = JSON.parse(localStorage.sampleAuthCodeList)
  } catch (error) {
    console.warn(error)
  }
  return useCodes?.some(m => m === code)
}

// 多权限或判断
export const isPermissions = (authList, codeList) => {
  if (authList?.length === 0 || codeList?.length === 0) return false
  return codeList?.some(item => authList?.includes(item))
}
// 灵感集区分父子灵感集的权限判断
export const hasInspirationAuth = (isChild, auth, codeList) => {
  if (isChild) {
    const childCodeList = codeList?.filter(item => item.includes('FC'))
    return isPermissions(auth, childCodeList)
  }
  const parentCodeList = codeList?.filter(item => !item.includes('FC'))
  return isPermissions(auth, parentCodeList)
}

export const isGlobalAuthVersion = (code) => { // 全局区分版本
  const _mealAuth = JSON.parse(localStorage.mealAuthCodeList)
  return _mealAuth?.skuId === code
}
